import { render, staticRenderFns } from "./AddPracticeTest.vue?vue&type=template&id=fa5a09f6&scoped=true"
import script from "./AddPracticeTest.vue?vue&type=script&lang=js"
export * from "./AddPracticeTest.vue?vue&type=script&lang=js"
import style0 from "./AddPracticeTest.vue?vue&type=style&index=0&id=fa5a09f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5a09f6",
  null
  
)

export default component.exports